







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import FeeSheetRulesGrid from '../components/fee-sheet-rules/fee-sheet-rules-grid.vue';

@Component({
  components: {
    PageTitle,
    FeeSheetRulesGrid
  }
})
export default class FeeSheetRules extends Vue {}
